/** Role-scoped URL prefix (matches App.js rolePath). */
export function normalizeRoleSlug(rawRole) {
  if (!rawRole) return "teacher";
  const s = String(rawRole).trim().toLowerCase().replace(/[_\s]+/g, "");
  if (s === "institute") return "admin";
  if (s === "superadmin" || s === "superadministrator") return "superadmin";
  return s || "teacher";
}

export function getRolePathFromUser(user) {
  const raw = user?.role?.slug || user?.role || "teacher";
  return `/${normalizeRoleSlug(raw)}`;
}
